// userReducer.ts
import { UserData } from '../type';
import { SET_USER_DATA } from '../actions';
import Action from '../actions';

// Ensure initialState is correctly typed
const initialState: UserData = null;

// Correctly type the reducer function
const userReducer = (state: UserData = initialState, action: Action): UserData => {
  switch (action.type) {
    case SET_USER_DATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default userReducer;
